var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationProfile = function SvgSimpleIllustrationProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ED7DE",
    d: "M38 34.889C38 37.222 36.448 38 34.114 38H13.89c-2.478 0-3.89-.778-3.89-3.111C10 28.667 17.001 24 24 24c6.998 0 14 4.667 14 10.889ZM30.225 16.222a6.223 6.223 0 1 1-12.445 0 6.223 6.223 0 0 1 12.445 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M38 34.889C38 37.222 36.448 38 34.114 38H13.89c-2.478 0-3.89-.778-3.89-3.111C10 28.667 17.001 24 24 24c6.998 0 14 4.667 14 10.889ZM30.225 16.222a6.223 6.223 0 1 1-12.445 0 6.223 6.223 0 0 1 12.445 0Z"
  })));
};
export default SvgSimpleIllustrationProfile;